import React, { useState, useEffect } from 'react'
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import RichTextEditor from './RichTextEditor'
import RichTextPreview from './RichTextPreview'

const RichTextFieldModal = ({
	value,
	onChange,
	label
}) => {
	const [activeTab, setActiveTab] = useState('editar')
	const [rawState, setRawState] = useState('')
	const [showModal, setShowModal] = useState(false)
	const [initialValue, setInitialValue] = useState(value)

	// Función helper para determinar qué contenido mostrar
	const displayContent = rawState || (value ? JSON.parse(value) : '') || ''

	const hasChanges = value !== initialValue

	// Efecto para manejar cambios en rawState
	useEffect(() => {
		if (rawState) {
			console.log('acá?')
			onChange(JSON.stringify(rawState))
		}
	}, [rawState])

	return (
		<div>
			{label && <div className="mb-2">{label}</div>}

			{/* Placeholder */}
			<div
				className="border rounded p-3"
				style={{
					backgroundColor: '#f8f9fa',
					minHeight: '100px'
				}}
			>
				<div className="d-flex justify-content-end">
					<Button
						variant="primary"
						size="sm"
						onClick={() => setShowModal(true)}
					>
						<i className="fa fa-pencil"></i> Modificar
					</Button>
				</div>

				<div className="mt-2">
					{displayContent ? (
						<div className={`ps-2 ${hasChanges ? 'border-start border-3 border-success' : ''}`}>
							<RichTextPreview rawContent={displayContent} />
						</div>
					) : (
						<div className="text-muted">
							<i className="fa fa-info-circle me-1"></i>
							Sin contenido...
						</div>
					)}
				</div>
			</div>

			{/* Modal */}
			<Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
				<Modal.Header closeButton>
					<Modal.Title>Editar contenido</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Tabs
						activeKey={activeTab}
						onSelect={(k) => setActiveTab(k)}
						className="mb-3"
					>
						<Tab eventKey="editar" title={<><i className="fa fa-pencil"></i> Editar</>}>
							<RichTextEditor
								setHTML={setRawState}
								existingHTML={value}
								setRawState={setRawState}
								existingRawState={value}
							/>
						</Tab>
						<Tab eventKey="previsualizar" title={<><i className="fa fa-eye"></i> Previsualizar</>}>
							<RichTextPreview rawContent={displayContent} />
						</Tab>
					</Tabs>
				</Modal.Body>
			</Modal>
		</div>
	)
}

export default RichTextFieldModal